{
	"completed": {
		"description": "The export is ready. The download should start automatically.",
		"title": "Export ready"
	},
	"details": {
		"expires_at": "Expires at",
		"format": "Format",
		"rows": "Rows",
		"unknown": "Unknown"
	},
	"dialog": {
		"button": "Export",
		"downloaded": "Download started.",
		"format": {
			"csv": "CSV",
			"xlsx": "XLSX"
		},
		"started": "Export queued. You will receive it by email when it is ready."
	},
	"download_again": "Download again",
	"error": {
		"title": "Export unavailable"
	},
	"expired": {
		"description": "This export is no longer available.",
		"title": "Export expired"
	},
	"failed": {
		"description": "The export could not be generated.",
		"title": "Export failed"
	},
	"loading": "Loading export...",
	"manager": {
		"description": "The files to hand to the authorities that check the calls. Every download is recorded, since it holds students' data.",
		"page_title": "Export",
		"ranking_in_force": "Version of the ranking in force",
		"ranking_none": "No ranking until the call opens",
		"ranking_provisional": "Provisional ranking, calculated now",
		"ranking_title": "Ranking (CSV or XLSX)"
	},
	"page_title": "Export",
	"refresh": "Refresh",
	"status": {
		"completed": "Completed",
		"expired": "Expired",
		"failed": "Failed",
		"pending": "Pending",
		"running": "Running"
	},
	"waiting": {
		"description": "The export is still being prepared.",
		"title": "Export in progress"
	}
}
